import { render, staticRenderFns } from "./clockin-add-or-update.vue?vue&type=template&id=49538856&scoped=true"
import script from "./clockin-add-or-update.vue?vue&type=script&lang=js"
export * from "./clockin-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./clockin-add-or-update.vue?vue&type=style&index=0&id=49538856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49538856",
  null
  
)

export default component.exports